module.exports = "/hwa/_next/static/images/furniture-collection-1989ee869d9a09d9564e1b3d4d679aa5.png";